module.exports = __webpack_public_path__ + "media/images/iconSquadBet__pickArrow-73736c366349c81f74d722591ba63df8.png";